export default __webpack_public_path__ + "static/media/gal-6.29b2e94d.jpeg";